import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { modeAtom } from '../state/atoms';

/** "Take off here" / "Land here", for buttons that set the origin. */
export function useOriginActionLabel() {
  const { t } = useTranslation('glide');
  return t(`originAction.${useAtomValue(modeAtom)}`);
}
